// Reading aids belong on the page, not interleaved into shared Scripture text.
export default function readingText(element) {
  if (!element) return '';
  const copy = element.cloneNode(true);
  copy.querySelectorAll('rt, rp').forEach(node => node.remove());
  return copy.textContent.trim();
}
